import Service from "../../AuthService";

const TaxPayment = {
    getTaxPayment(page) {
        return Service.get("/tax-payment?page="+page);
    },
    showTaxPayment(id) {
        return Service.get("/tax-payment/" + id);
    },
    updateTaxPayment(id, data) {
        return Service.put("/tax-payment/" + id, data);
    },
    createTaxPayment(data) {
        return Service.post("/tax-payment", data);
    },
    deleteTaxPayment(id) {
        return Service.delete("/tax-payment/" + id);
    },
    searchTaxPayment(page,data){
        return Service.post("/search-tax-payment?page="+page,data);
    },
    selectTaxPayment(data){
        return Service.post("/select-tax-payment",data);
    },
    //tax payment account
    getTaxPaymentAccount(page,code){
        return Service.get('/tax-payment-account?page='+page+'&code='+code);
    },
    showTaxPaymentAccount(id){
        return Service.get('/tax-payment-account/'+id);
    },
    createTaxPaymentAccount(data){
        return Service.post('/tax-payment-account',data);
    },
    editTaxPaymentAccount(id,data){
        return Service.put('/tax-payment-account/'+id,data);
    },
    deleteTaxPaymentAccount(id){
        return Service.delete('/tax-payment-account/'+id);
    },
    generateTaxPaymentCode(){
        return Service.get('/generate_tax_payment_code');
    },
    getAllTaxPaymentAccount(){
        return Service.get('/get_tax_payment_account_all');
    },
    closeTaxPayment(date){
        return Service.get(`/close_tax_payment?date=${date}`);
    }
};

export default TaxPayment
